"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiMailClosed16 = {
    paths: [
        {
            path: 'M14.9991283,0 C15.5518945,0 16,0.455760956 16,1.00247329 L16,10.9975267 C16,11.5511774 15.5553691,12 14.9991283,12 L1.00087166,12 C0.448105505,12 0,11.544239 0,10.9975267 L0,1.00247329 C0,0.448822582 0.444630861,0 1.00087166,0 L14.9991283,0 Z M14,2.414 L8.70710678,7.70710678 C8.31658249,8.09763107 7.68341751,8.09763107 7.29289322,7.70710678 L7.29289322,7.70710678 L2,2.415 L2,10 L14,10 L14,2.414 Z M11.5854328,2.00035366 L4.1078399,1.69362633 C5.13341246,2.7191989 6.43079916,4.0165856 8,5.58578644 C9.45989507,4.12589137 10.6550393,2.93074711 11.5854328,2.00035366 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Mail Closed',
    width: 16,
    height: 12,
};
var muiMailClosed24 = {
    paths: [
        {
            path: 'M22.9993054,0 C23.5519738,0 24,0.444946289 24,0.993397683 L24,17.0066023 C24,17.5552407 23.5525308,18 22.9993054,18 L1.00069463,18 C0.448026248,18 0,17.5550537 0,17.0066023 L0,0.993397683 C0,0.444759292 0.44746922,0 1.00069463,0 L22.9993054,0 Z M22,3.414 L12.7071068,12.7071068 C12.3165825,13.0976311 11.6834175,13.0976311 11.2928932,12.7071068 L11.2928932,12.7071068 L2,3.415 L2,16 L22,16 L22,3.414 Z M20.584,2 L3.415,2 L12,10.5857864 L20.584,2 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Mail Closed',
    width: 24,
    height: 18,
};
var muiMailClosed = {
    base: muiMailClosed16,
    smIcon: muiMailClosed16,
    lgIcon: muiMailClosed24,
};
exports.muiMailClosed = muiMailClosed;
//# sourceMappingURL=mailClosed.js.map